export default "__VITE_ASSET__D8MiI6wL__"